import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Footer = ({ responseGenerate, inputText, setInputText, mode, setMode, lastUpdate }) => {

  // Função para enviar a mensagem
  const handleSubmit = () => {
    if (inputText.trim() !== "") {
      responseGenerate(inputText, setInputText);
      setInputText("");  // Limpa o campo de texto
    }
  };

  // Função para lidar com a tecla Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();  // Evita quebra de linha no input
      handleSubmit();      // Chama a função de envio
    }
  };

  const toggleMenu = () => {
    const menu = document.querySelector(".menu-float");
    menu.classList.toggle("active");
  };

  return (<>
    <div style={{
      background: "linear-gradient(0deg, #f7fdfa, #f7fdfa00)",
      height: 100,
      position: "fixed",
      width: "100%",
      left: 0,
      bottom: 75,
      zIndex: 5
    }}>

      <div className="footer-container">
        <div className="icon-button" onClick={toggleMenu}>
          <FontAwesomeIcon
            icon={faSliders}
          />
          <div
    			  className="menu-float"
    			  onCopy={(e) => e.preventDefault()}
    			  onCut={(e) => e.preventDefault()}
    			  onContextMenu={(e) => e.preventDefault()}
    			  onMouseDown={(e) => e.preventDefault()}
    			  style={{ userSelect: 'none' }}
    			>
            <div className={mode == "Report" ? "selected" : ""} onClick={()=>setMode("Report")}>Relatório</div>
            <div className={mode == "Raw" ? "selected" : ""} onClick={()=>setMode("Raw")}>Resposta Bruta</div>
            <div className={mode == "Reasoning" ? "selected" : ""} onClick={()=>setMode("Reasoning")}>Racional de Cálculo</div>
            {/*<div>Memória</div>*/}
          </div>
        </div>
        <div className="footer">
          <input 
          	type="text" 
          	placeholder="Escreva uma mensagem" 
          	value={inputText}
          	onChange={(e) => setInputText(e.target.value)}
          	onKeyDown={handleKeyDown}
          />
          <button onClick={handleSubmit}>
            <FontAwesomeIcon
              icon={faPaperPlane}
            />
            Enviar
          </button>
        </div>
        <center style={{
          fontFamily: "Arial, sans-serif",
          color: "rgb(51, 51, 51)",
          fontSize: 16,
          position: "fixed",
          width: "100vw",
          bottom: 10,
          left: 0
        }}>
          <small
            style={{
              fontSize: "13px",
              color: "#64748b",
              textAlign: "left",
              fontWeight: 300
            }}
          >
            {!lastUpdate ? "Não foi possível detectar a atualização das bases" : "Última atualização das bases em " + lastUpdate}
          </small>
        </center>
      </div>
     </div>
    <div style={{position: "fixed", width: "100%", left: 0, background: "#f7fdfa", zIndex: 3, height: 75, bottom: 0}}></div>
  </>);
};

export default Footer;